class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(tab));
      tab.addEventListener('keydown', this.onKeydown.bind(this));
    });
  }

  selectTab(tab) {
    if (tab.getAttribute('aria-selected') === 'true') return;

    this.tabs.forEach((t) => {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
    });

    this.panels.forEach((panel) => {
      panel.classList.remove('is-active');
      panel.setAttribute('hidden', '');
    });

    tab.classList.add('is-active');
    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');

    const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
    if (panel) {
      panel.classList.add('is-active');
      panel.removeAttribute('hidden');
    }
  }

  onKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let nextIndex = null;

    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    const nextTab = this.tabs[nextIndex];
    nextTab.focus();
    this.selectTab(nextTab);
  }
}

customElements.define('product-tabs', ProductTabs);
